<template>
  <v-card>
    <div class="pa-4">
      <div class="d-flex justify-space-between align-center">
        <h3 class="text">Thông tin cơ bản</h3>
        <v-btn
          v-if="!item.released && $auth.policies['update-survey']"
          outlined
          color="#0D47A1"
          @click="$refs.popupSurvey.openDialog('update', item)"
        >
          Sửa
        </v-btn>
      </div>
      <div class="mt-2">
        <div class="d-flex">
          <div class="text title-info">Tiêu đề</div>
          <div class="text">{{ item.title }}</div>
        </div>
        <div class="d-flex mt-4">
          <div class="text title-info">Mô tả</div>
          <!-- TODO: change description to display HTML (v-html) -->
          <div class="text" style="white-space: pre-line">
            {{ item.description }}
          </div>
        </div>
        <div class="d-flex mt-4">
          <div class="text title-info">Nguời tạo</div>
          <div class="text">
            {{ $_get(item, 'createdBy.name', '') }}
          </div>
        </div>
        <div class="d-flex mt-4">
          <div class="text title-info">Ngày tạo</div>
          <div class="text">
            {{ item.createdAt | ddmmyyyy }}
          </div>
        </div>
        <div class="d-flex mt-4">
          <div class="text title-info">Ngày kết thúc</div>
          <div class="text">
            {{ item.deadline | ddmmyyyy }} <span class="caption">(tính đến 23:59:59)</span>
          </div>
        </div>
        <div class="d-flex mt-4">
          <div class="text title-info">Trạng thái hiển thị</div>
          <div class="text">
            <v-chip :color="item.status | getColorStatusSurvey" small class="white--text">{{
              item.status | getTextStatusSurvey
            }}</v-chip>
          </div>
        </div>
        <div class="d-flex mt-4">
          <div class="text title-info">Trạng thái hết hạn</div>
          <div class="text">
            <v-chip :color="item.isExpired | surveyExpireColor" small class="white--text">{{
              item.isExpired | surveyIsExpiredText
            }}</v-chip>
          </div>
        </div>
        <div class="d-flex mt-4">
          <div class="text title-info">Áp dụng</div>
          <div class="text">
            <v-chip class="mr-2" v-for="(item, index) in listTargets" :key="index">
              {{ item.title || '' }}
            </v-chip>
          </div>
        </div>
        <div class="d-flex mt-4">
          <div class="text title-info">Số người đã trả lời</div>
          <div class="text">{{ item.countReply || 0 }}</div>
        </div>
      </div>
    </div>
    <PopupSurvey ref="popupSurvey" />
  </v-card>
</template>

<script>
import { mapMutations, mapState } from 'vuex'
import { get } from 'lodash'
import PopupSurvey from '../survey/PopupSurvey.vue'
export default {
  components: { PopupSurvey },
  computed: {
    ...mapState({
      item: state => state.survey.item
    }),
    listTargets() {
      if (this.item.applyFor === 'all') return [{ title: 'Toàn trường' }]
      if (this.item.applyFor === 'specific') return [{ title: `${this.item.students.length} học sinh` }]
      return [
        ...get(this, 'item.grades', []),
        ...get(this, 'item.classes', []),
        ...get(this, 'item.academicLevels', [])
      ]
    }
  },
  methods: {
    ...mapMutations({
      setState: 'survey/setState'
    })
  }
}
</script>

<style lang="scss" scoped>
.title-info {
  min-width: 170px;
}
</style>
